// extracted by mini-css-extract-plugin
export var aircallIframe = "_i0-3";
export var fabContainer = "_i0-5";
export var fabRinging = "_i0-6";
export var loadingOverlay = "_i0-4";
export var pulse = "_i0-7";
export var widgetContent = "_i0-2";
export var widgetPanel = "_i0-0";
export var widgetPanelExpanded = "_i0-1";